<modal
  [id]="id"
  [widthClass]="'tw-w-11/12 md:tw-w-[576px]'"
  [heightClass]="'tw-h-auto'"
  [showHeaderDivider]="false"
  [showFooterDivider]="false"
  [closeButtonEnabled]="true"
  [enableBackdropClose]="false"
  [escapeToClose]="false"
  (onCloseModal)="handleModalClose()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-items-center -tw-mt-4 tw-px-4">
    <svg class="tw-mb-4 tw-h-12 tw-w-12" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path
        d="M24 0C27.375 0 30.375 1.96875 31.875 4.875C34.9688 3.84375 38.5312 4.59375 40.9688 7.03125C43.4062 9.46875 44.1562 13.0312 43.125 16.125C46.0312 17.625 48 20.625 48 24C48 27.4688 46.0312 30.4688 43.125 31.9688C44.1562 35.0625 43.4062 38.5312 40.9688 40.9688C38.5312 43.4062 34.9688 44.1562 31.875 43.2188C30.375 46.125 27.375 48 24 48C20.5312 48 17.5312 46.125 16.0312 43.2188C12.9375 44.1562 9.46875 43.4062 7.03125 40.9688C4.59375 38.5312 3.84375 35.0625 4.78125 31.9688C1.875 30.4688 0 27.4688 0 24C0 20.625 1.875 17.625 4.78125 16.125C3.84375 13.0312 4.59375 9.46875 7.03125 7.03125C9.46875 4.59375 12.9375 3.84375 16.0312 4.875C17.5312 1.96875 20.5312 0 24 0ZM33.0938 21.0938C33.9375 20.25 33.9375 18.8438 33.0938 18C32.1562 17.0625 30.75 17.0625 29.9062 18L21 26.9062L17.3438 23.25C16.4062 22.3125 15 22.3125 14.1562 23.25C13.2188 24.0938 13.2188 25.5 14.1562 26.3438L19.4062 31.5938C20.25 32.5312 21.6562 32.5312 22.5938 31.5938L33.0938 21.0938Z"
        fill="#0E9F6E"
      />
    </svg>

    <div class="tw-flex tw-flex-col tw-gap-2 tw-mt-4 tw-mb-6">
      <h2 class="tw-text-center tw-justify-start tw-text-gray-700 tw-text-lg tw-font-bold tw-font-['Inter'] tw-leading-7">
        {{ titleKey | translate }}
      </h2>

      <p class="tw-inline-flex tw-gap-1.5 tw-text-center tw-justify-center tw-text-yellow-500 tw-text-sm tw-font-medium tw-font-['Inter'] tw-leading-5">
        <svg class="tw-h-4 tw-w-4 tw-shrink-0 tw-fill-yellow-500" viewBox="0 0 16 16" aria-hidden="true">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.448 2.79c.69-1.22 2.414-1.22 3.104 0l5.316 9.41c.677 1.198-.19 2.675-1.552 2.675H2.684c-1.362 0-2.23-1.477-1.552-2.675l5.316-9.41ZM8 6.25a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V7A.75.75 0 0 1 8 6.25Zm0 6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
          />
        </svg>
        <span>{{ 'v2.orgSettings.apiKeys.secretWarning' | translate }}</span>
      </p>

      <p class="tw-text-center tw-justify-center tw-text-gray-500 tw-text-sm tw-font-normal tw-font-['Inter'] tw-leading-5">
        {{ 'v2.orgSettings.apiKeys.secretHint' | translate }}
      </p>
    </div>

    <div class="tw-flex tw-w-full tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center">
      <div class="tw-relative tw-min-w-0 tw-w-full tw-flex-1">
        <div
          class="tw-flex tw-h-[58px] tw-min-w-0 tw-items-center tw-rounded-lg tw-border tw-border-gray-300 tw-bg-transparent tw-px-4 dark:tw-border-gray-600"
        >
          <p
            class="tw-min-w-0 tw-truncate tw-font-inter tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white"
            [attr.title]="token"
          >
            {{ token }}
          </p>
        </div>
        <span
          class="tw-pointer-events-none tw-absolute tw-start-2 tw-top-0 -tw-translate-y-1/2 tw-bg-white tw-px-1 tw-font-inter tw-text-xs tw-font-medium tw-text-gray-700 dark:tw-bg-gray-800 dark:tw-text-gray-400"
        >
          {{ 'v2.orgSettings.apiKeys.tokenLabel' | translate }}
        </span>
      </div>

      <button
        type="button"
        class="tw-inline-flex tw-h-[58px] tw-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-bg-blue-600 tw-px-5 tw-font-inter tw-text-sm tw-font-medium tw-text-white tw-transition-colors hover:tw-bg-blue-700"
        (click)="copyToken()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 10 12" fill="none" aria-hidden="true">
          <path
            d="M8.89475 5.75118e-06H5.90168C5.67649 -0.000586605 5.45342 0.044585 5.24538 0.132906C5.03735 0.221226 4.84848 0.350941 4.68971 0.514542L4.28572 0.927225C4.22237 0.995968 4.17646 1.07958 4.15201 1.17074H6.60909C7.2101 1.17646 7.78434 1.42621 8.20579 1.86519C8.62724 2.30417 8.86145 2.89651 8.85704 3.5122V9.36586H8.89475C9.19271 9.36032 9.47637 9.23396 9.68353 9.0145C9.8907 8.79504 10.0045 8.50038 9.99987 8.19513V1.17074C10.0045 0.865486 9.8907 0.570826 9.68353 0.351364C9.47637 0.131903 9.19271 0.00554845 8.89475 5.75118e-06Z"
            fill="white"
          />
          <path
            d="M3.14289 5.26828V2.34146C3.14364 2.25614 3.16317 2.17211 3.20003 2.0956C2.82194 2.17642 2.47515 2.3687 2.20234 2.64877L0.585805 4.30477C0.328154 4.57043 0.147208 4.90388 0.0629606 5.26828H3.14289Z"
            fill="white"
          />
          <path
            d="M6.60909 2.04878H4.19829C4.25285 2.13639 4.28307 2.23758 4.28572 2.34146V5.26829C4.28572 5.57879 4.16531 5.87657 3.95099 6.09612C3.73667 6.31568 3.44598 6.43902 3.14289 6.43902H0.00010616V10.5366C-0.00447394 10.9194 0.139309 11.2884 0.399926 11.5627C0.660543 11.837 1.01672 11.9943 1.39036 12H6.60909C6.98278 11.9943 7.33901 11.8371 7.59972 11.5627C7.86043 11.2884 8.00434 10.9194 7.99991 10.5366V3.51219C8.00434 3.12937 7.86043 2.76036 7.59972 2.48604C7.33901 2.21173 6.98278 2.05449 6.60909 2.04878Z"
            fill="white"
          />
        </svg>
        {{ 'v2.orgSettings.apiKeys.copy' | translate }}
      </button>
    </div>
  </div>
</modal>

<modal
  [id]="closeWarningModalId"
  [widthClass]="'tw-w-11/12 md:tw-w-[420px]'"
  [heightClass]="'tw-h-auto'"
  [showHeaderDivider]="false"
  [showFooterDivider]="false"
  [closeButtonEnabled]="true"
  [enableBackdropClose]="true"
  [escapeToClose]="true"
  (onCloseModal)="handleCloseWarningDismiss()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-px-6">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <g clip-path="url(#clip0_copy_api_key_close_warning)">
        <path
          d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34873 18.9426 4.80688 17.0679 2.93215C15.1931 1.05741 12.6513 0.0029116 10 0ZM10 15C9.80222 15 9.60888 14.9413 9.44443 14.8315C9.27998 14.7216 9.15181 14.5654 9.07612 14.3827C9.00044 14.2 8.98063 13.9989 9.01922 13.8049C9.0578 13.6109 9.15304 13.4327 9.2929 13.2929C9.43275 13.153 9.61093 13.0578 9.80491 13.0192C9.99889 12.9806 10.2 13.0004 10.3827 13.0761C10.5654 13.1518 10.7216 13.28 10.8315 13.4444C10.9414 13.6089 11 13.8022 11 14C11 14.2652 10.8946 14.5196 10.7071 14.7071C10.5196 14.8946 10.2652 15 10 15ZM11 11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12C9.73479 12 9.48043 11.8946 9.2929 11.7071C9.10536 11.5196 9 11.2652 9 11V6C9 5.73478 9.10536 5.48043 9.2929 5.29289C9.48043 5.10536 9.73479 5 10 5C10.2652 5 10.5196 5.10536 10.7071 5.29289C10.8946 5.48043 11 5.73478 11 6V11Z"
          fill="#9CA3AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_copy_api_key_close_warning">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <div class="tw-flex tw-flex-col tw-gap-2 tw-text-center">
      <p class="tw-font-inter tw-text-base tw-font-bold tw-leading-6 tw-text-gray-900 dark:tw-text-white">
        {{ 'v2.orgSettings.apiKeys.closeWithoutCopyTitle' | translate }}
      </p>
      <p class="tw-font-inter tw-text-base tw-font-normal tw-leading-6 tw-text-gray-500 dark:tw-text-gray-400">
        {{ 'v2.orgSettings.apiKeys.closeWithoutCopyMessage' | translate }}
      </p>
    </div>
  </div>

  <div slot="footer" class="tw-flex tw-items-center tw-justify-center tw-gap-4 tw-px-6 tw-pb-6 tw-pt-5">
    <button
      type="button"
      class="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-bg-blue-600 tw-px-3 tw-py-2 tw-font-inter tw-text-sm tw-font-medium tw-text-white hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-blue-300"
      (click)="goBackToCopyModal()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <g clip-path="url(#clip0_51316_53250)">
          <path
            d="M8.32137 12C8.0126 11.9999 7.71649 11.8736 7.49819 11.6488L2.8409 6.85472C2.62262 6.62997 2.5 6.32517 2.5 6.00736C2.5 5.68956 2.62262 5.38476 2.8409 5.16001L7.49819 0.365896C7.6056 0.251425 7.73407 0.160118 7.87613 0.0973047C8.01818 0.034491 8.17096 0.00142813 8.32556 4.52529e-05C8.48016 -0.00133763 8.63347 0.0289869 8.77657 0.0892499C8.91966 0.149513 9.04966 0.238507 9.15898 0.35104C9.2683 0.463573 9.35475 0.597391 9.4133 0.744686C9.47184 0.89198 9.5013 1.0498 9.49996 1.20894C9.49861 1.36808 9.46649 1.52535 9.40547 1.67158C9.34445 1.8178 9.25575 1.95005 9.14454 2.06061L5.31043 6.00736L9.14454 9.95411C9.30733 10.1217 9.41818 10.3353 9.46308 10.5677C9.50799 10.8002 9.48493 11.0411 9.39683 11.2601C9.30872 11.4791 9.15953 11.6662 8.9681 11.7979C8.77668 11.9296 8.55161 11.9999 8.32137 12Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_51316_53250">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
      {{ 'v2.orgSettings.apiKeys.goBack' | translate }}
    </button>
    <button
      type="button"
      class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-red-700 tw-bg-white tw-px-3 tw-py-2 tw-font-inter tw-text-sm tw-font-medium tw-text-red-700 hover:tw-bg-red-50 focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-red-300 dark:tw-bg-gray-800 dark:hover:tw-bg-red-900/20"
      (click)="closeWithoutCopying()"
    >
      {{ 'v2.orgSettings.apiKeys.closeAnyway' | translate }}
    </button>
  </div>
</modal>
